export default __webpack_public_path__ + "static/media/img (1).cb98ee21.jpg";